import React, { useState } from 'react'
import DatePicker from 'react-multi-date-picker'
import TimePickerPlugin from 'react-multi-date-picker/plugins/time_picker'

import './styles.scss'
import ModalWrapper from 'components/ModalWrapper'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const TimePickerRender = ({ onChange }) => (
  <div className='time-picker'>
    <figure className='time-picker__icon'>
      <img src={getStaticImage('/icons/orange-brand/icon-clock-primary.svg')} alt='Time' />
    </figure>
    <DatePicker
      disableDayPicker
      format='HH:mm:ss'
      plugins={[<TimePickerPlugin key={0} />]}
      placeholder={lang('dashboard_set-time')}
      onChange={onChange}
    />
  </div>
)

const TimePicker = ({ mode, modalOptions, onChange }) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')

  const handleValue = value => {
    const hours = value.hour <= 9 ? `0${value.hour}` : value.hour
    const minutes = value.minute <= 9 ? `0${value.minute}` : value.minute
    const seconds = value.second <= 9 ? `0${value.second}` : value.second
    const time = `${hours}:${minutes}:${seconds}`
    setValue(time)
    if (mode === 'embed' && typeof onChange === 'function') onChange(time)
  }

  const handleModalSave = () => {
    if (typeof onChange !== 'function') return
    if (!value) return setError(lang('dashboard_must-set-time'))
    onChange(value)
    if (typeof modalOptions?.toggle === 'function') modalOptions.toggle()
  }

  if (mode === 'embed') {
    return <TimePickerRender onChange={handleValue} />
  }

  if (mode === 'modal') {
    return (
      <ModalWrapper
        isOpen={modalOptions?.isOpen}
        toggle={modalOptions?.toggle}
        header={modalOptions?.title}
        legend={modalOptions?.legend}
        body={<TimePickerRender onChange={handleValue} />}
        eventBtnTxt={lang('buttons_save')}
        eventBtn={handleModalSave}
        cancelBtnTxt={lang('buttons_cancel')}
        cancelBtn={modalOptions?.toggle}
        error={error}
      />
    )
  }

  return null
}

export default TimePicker
